import { normalize, schema } from 'normalizr';

export const normalized = <Schema>(data: any, schema: schema.Entity | schema.Entity[]) => normalize<any, Schema>(data, schema);
